'use strict';

(function () {
  'use strict';

  angular.module('msGoals').controller('EditGoalCtrl', EditGoalCtrl);

  EditGoalCtrl.$inject = ['step', 'close', 'goalSvc', 'goal', 'editMode', 'focus'];

  function EditGoalCtrl(step, close, goalSvc, goal, editMode, focus) {
    var vm = this;

    vm.chooseImage = chooseImage;
    vm.advanceSection = advanceSection;
    vm.saveGoal = saveGoal;
    vm.closeModal = closeModel;
    vm.nextDisabled = nextDisabled;
    vm.deleteConfirm = deleteConfirm;

    activate();

    ////////////////

    function activate() {
      vm.title = 'EditGoalCtrl';
      vm.currentSection = step;
      vm.habit = { widgets: [] };
      vm.editMode = editMode;
      if (goal) {
        vm.activity = angular.copy(goal);
      }

      vm.defaultImages = ['https://mystrength.imgix.net/goal_images/ellehem-693.jpg', 'https://mystrength.imgix.net/goal_images/ales-krivec-15949.jpg', 'https://mystrength.imgix.net/goal_images/colton-brown-19410.jpg', 'https://mystrength.imgix.net/goal_images/dustin-lee-19667.jpg', 'https://mystrength.imgix.net/goal_images/kari-shea-99873.jpg', 'https://mystrength.imgix.net/goal_images/joao-silas-66191.jpg', 'https://mystrength.imgix.net/goal_images/luis-llerena-14739.jpg', 'https://mystrength.imgix.net/goal_images/simon-schmitt-29709.jpg', 'https://mystrength.imgix.net/goal_images/todd-quackenbush-701.jpg', 'https://mystrength.imgix.net/goal_images/spacex-71876.jpg', 'https://mystrength.imgix.net/goal_images/photo-1422050478545-9f9383263965.jpeg', 'https://mystrength.imgix.net/goal_images/photo-1422808890527-76d0b804b122.jpeg', 'https://mystrength.imgix.net/goal_images/photo-1450101215322-bf5cd27642fc.jpeg', 'https://mystrength.imgix.net/goal_images/photo-1464716821973-e1031cfa43dc.jpeg', 'https://mystrength.imgix.net/goal_images/photo-1470074558764-4e577e98bc85.jpeg', 'https://mystrength.imgix.net/goal_images/photo-1471193945509-9ad0617afabf.jpeg', 'https://mystrength.imgix.net/goal_images/photo-1471970394675-613138e45da3.jpeg', 'https://mystrength.imgix.net/goal_images/photo-1472721197516-50036fdb155b.jpeg', 'https://mystrength.imgix.net/goal_images/photo-1473186505569-9c61870c11f9.jpeg', 'https://mystrength.imgix.net/goal_images/photo-20161027114033.jpg'];
      focus.byId('modal-title', 100);
    }

    function nextDisabled() {
      return !(vm.currentSection === 0 && vm.activity && vm.activity.description);
    }

    function chooseImage(defaultImageIndex) {
      vm.activity.image = vm.defaultImages[defaultImageIndex];
      if (vm.editMode) {
        saveGoal();
        focus.byId('edit-goal-' + goal.id, 1000);
      } else {
        vm.advanceSection(vm.currentSection);
      }
    }

    function advanceSection(currentSection) {
      vm.currentSection = currentSection + 1;
      focus.byId('goal-step-description');
    }

    function saveGoal() {
      // Goal is now stored in description attr, but title is a required field so fill it.
      vm.activity.title = 'goal';
      // lock the button to ensure we don't double click
      // (no need to unset as ctrl is torn down on modal close)
      vm.isProcessing = true;
      if (vm.habit.name) {
        if (vm.activity.sections) {
          var dataCopy = angular.copy(vm.activity.sections);
          vm.habit.title = vm.habit.name;
          dataCopy.push(vm.habit);

          vm.activity.sections = dataCopy;
        } else {
          vm.activity.sections = [vm.habit];
        }
      }
      goalSvc.saveGoal(vm.activity).then(function () {
        return closeModel();
      });
    }

    function closeModel() {
      // 200ms pause to let ngAnimate hide the modal.
      close(false, 200);
    }

    function deleteConfirm(goal) {
      goal.status = 'DELETED';
      goalSvc.saveGoal(goal).then(function () {
        closeModel();
      });
    }
  }
})();